import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FooterModel } from '../../../models/footer.model';
import { FooterService } from '../../../services/footer.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  public info$: Observable<FooterModel>;

  @Input() clientVersion: string = '';

  constructor(private footerService: FooterService) {}

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.info$ = this.footerService.getInfo();
  }
}
